var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dates',{attrs:{"read_only":_vm.read_only}}),_vm._v(" "),_c('price',{attrs:{"deal":_vm.property.deal,"read_only":_vm.read_only}}),_vm._v(" "),_c('fees-paid',{attrs:{"read_only":_vm.read_only}}),_vm._v(" "),_c('our-side',{attrs:{"read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }